export default __webpack_public_path__ + "static/media/bangalore.b9021212.png";